import { render, staticRenderFns } from "./VideoModalPlayer.vue?vue&type=template&id=3b6046e2&scoped=true"
import script from "./VideoModalPlayer.vue?vue&type=script&lang=js"
export * from "./VideoModalPlayer.vue?vue&type=script&lang=js"
import style0 from "./VideoModalPlayer.vue?vue&type=style&index=0&id=3b6046e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6046e2",
  null
  
)

export default component.exports